var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DateTimePicker from './DateTimePicker';
// TODO:
// 1. Watch min/max time.
// 2. Accept value/minTime/maxTime as number in seconds always and also emit time as number in seconds.
//    Need to handle the conversion.
let TimePicker = class TimePicker extends Vue {
    render(h) {
        return h(DateTimePicker, {
            props: {
                error: this.error,
                value: this.value,
                showDate: false,
                minTime: this.min,
                maxTime: this.max,
                militaryTime: this.militaryTime,
                placeholder: 'Select time',
                disabled: this.disabled
            },
            on: {
                input: this.onInput,
                open: this.onOpen
            }
        });
    }
    /**
     * @param _changedValue _changedValue is the selected time with date
     * @param dateStr dateStr is a string representation of the latest selected Date object by the
     *              user. The string is formatted as per thedateFormatoption.
     * @param instance instance is the flatpickr object, containing various methods and properties.
     */
    onInput(_changedValue, dateStr, instance) {
        this.$emit('input', dateStr);
    }
    /**
     * @param _changedValue _changedValue is the selected time with date
     * @param dateStr dateStr is a string representation of the latest selected Date object by the
     *              user. The string is formatted as per thedateFormatoption.
     * @param instance instance is the flatpickr object, containing various methods and properties.
     */
    onOpen(_changedValue, dateStr, instance) {
        this.$emit('open', dateStr);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], TimePicker.prototype, "value", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], TimePicker.prototype, "error", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TimePicker.prototype, "militaryTime", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], TimePicker.prototype, "min", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], TimePicker.prototype, "max", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TimePicker.prototype, "disabled", void 0);
TimePicker = __decorate([
    Component({})
], TimePicker);
export default TimePicker;
//# sourceMappingURL=TimePicker.js.map